import React, { PureComponent } from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import InterestedIcon from 'material-ui/svg-icons/toggle/star';
// import { Link } from 'react-router';
// import RaisedButton from 'material-ui/RaisedButton';
// import CircularProgress from 'material-ui/CircularProgress';
// import CreateDialog from '../../packs/components/CreateDialog';
import styled from 'styled-components';
import { grey300, indigo500 } from 'material-ui/styles/colors';
// import CalendarContent from '../../calendar-page/components/CalendarContent';
import AddInterestFormDialog from './AddInterestFormDialog/index';
import PropTypes from 'prop-types';
import InterestsTable from './InterestsTable';
import DeleteDialog from './DeleteDialog';
import { fetchInterests, fetchTeams, fetchTournaments } from '../actions';
import RaisedButton from 'material-ui/RaisedButton';
import { addToQuery } from '../../helpers';
import CircularProgress from 'material-ui/CircularProgress';

const Loader = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 200px);
`;

const ErrorText = styled.h3`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    color: red;
`;

const HeaderWrapper = styled.div`
    display: flex;
    align-items: center;
`;

const Title = styled.h2`
    flex-grow: 1;
    color: ${indigo500};
    font-weight: inherit;

    svg {
        margin-right: 10px;
        transform: translate(0, 4px);
    }
`;

const ButtonWrapper = styled.div`
    display: inline-block;
    flex-grow: 1;
    text-align: right;

    button {
        color: #fff;
    }
`;

const CardStyle = {
    marginBottom: 15
};

const CardHeaderStyle = {
    borderBottom: `1px solid ${grey300}`,
    paddingTop: 0,
    paddingBottom: 0
};

const CardTextStyle = {
    padding: 0
};

const IconPacksStyle = {
    color: 'inherit'
};

class InterestsPage extends PureComponent {
    componentDidMount() {
        this.props.fetchInterests();
        this.props.fetchTournaments();
        this.props.fetchTeams();
    }

    onOpenAddInterestDialog() {
        addToQuery('addInterestDialog', 'newInterest');
    }

    render() {
        return (
            <Card style={CardStyle}>
                <CardHeader style={CardHeaderStyle}>
                    <HeaderWrapper>
                        <Title>
                            <InterestedIcon style={IconPacksStyle} />Interests
                        </Title>
                        <ButtonWrapper>
                            <RaisedButton onClick={this.onOpenAddInterestDialog} secondary labelColor="#fff">
                                Create
                            </RaisedButton>
                        </ButtonWrapper>
                    </HeaderWrapper>
                </CardHeader>
                <CardText style={CardTextStyle}>
                    {!this.props.isFinishedFetchInterests && (
                        <Loader>
                            <CircularProgress size={80} thickness={5} />
                        </Loader>
                    )}
                    {this.props.isFinishedFetchInterests && this.props.responseStatusFetchInterests !== 200 ? (
                        <ErrorText>An error occurred while saving, refresh the page, or try again later!</ErrorText>
                    ) : (
                        <InterestsTable />
                    )}
                </CardText>
                <DeleteDialog />
                <AddInterestFormDialog />
            </Card>
        );
    }
}

InterestsPage.propTypes = {
    isFinishedFetchInterests: PropTypes.bool,
    responseStatusFetchInterests: PropTypes.number,
    fetchInterests: PropTypes.func.isRequired,
    fetchTournaments: PropTypes.func.isRequired,
    fetchTeams: PropTypes.func.isRequired
};

export default connect(
    ({ requery = { queries: {} } }) => ({
        isFinishedFetchInterests:
            requery.queries['GET:userInterests'] && requery.queries['GET:userInterests'].isFinished,
        responseStatusFetchInterests:
            requery.queries['GET:userInterests'] && requery.queries['GET:userInterests'].status
    }),
    { fetchInterests, fetchTournaments, fetchTeams }
)(InterestsPage);



/** WEBPACK FOOTER **
 ** ../src/dash/front/interests-page/components/index.js
 **/